module.exports = __webpack_public_path__ + "img/Banner_AIShelfv2.158877df.png";